import { render, staticRenderFns } from "./editProgress.vue?vue&type=template&id=0471524a&scoped=true&"
import script from "./editProgress.vue?vue&type=script&lang=js&"
export * from "./editProgress.vue?vue&type=script&lang=js&"
import style0 from "./editProgress.vue?vue&type=style&index=0&id=0471524a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471524a",
  null
  
)

export default component.exports